/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataRetentionPolicyId } from "../../commons/types/DataRetentionPolicyId";
import { DataRetentionPolicyConfig } from "./DataRetentionPolicyConfig";
export const DataRetentionPolicy = core.serialization
    .object({
    id: DataRetentionPolicyId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
})
    .extend(DataRetentionPolicyConfig);
